import React from "react";
import ServiceListSection from "./ServiceListSection";

const Offers = ({ serviceListData }) => (
  <ServiceListSection title="Offers" serviceListData={serviceListData} />
);

export default Offers;
